import { createAction } from 'redux-actions';

const openGlobalDialogAction = createAction('OPEN_GLOBAL_DIALOG');
const closeGlobalDialogAction = createAction('CLOSE_GLOBAL_DIALOG');

export const openOrCloseGlobalDialog =
  (key: string, open: boolean, context?: any) => (dispatch: Function) => {
    if (open) {
      dispatch(openGlobalDialogAction({ key, context }));
    } else {
      dispatch(closeGlobalDialogAction({ key }));
    }
  };
